import React, { useEffect } from 'react';
import Header from './components/Header';
import TaxCalculator from './components/TaxCalculator';
import ValueProposition from './components/ValueProposition';
import InvestmentStructure from './components/InvestmentStructure';
import ComparisonSection from './components/ComparisonSection';
import TaxBenefitsExamples from './components/TaxBenefitsExamples';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // 앱이 처음 렌더링된 후 body에 클래스를 추가하여
    // 모든 애니메이션의 'transition'을 활성화합니다.
    document.body.classList.add('animations-ready');
  }, []); // 빈 배열이므로 최초 1회만 실행됩니다.

  return (
    // 전체 앱 컨테이너
    // - antialiased: 폰트 부드럽게 렌더링 (안티앨리어싱)
    // - bg-gray-50: 전체 배경색을 연한 회색으로 설정
    <div className="antialiased bg-gray-50" id="top">
      
      {/* 헤더 */}
      <Header />
      
      {/* 메인 컨텐츠 영역 */}
      <main>
        {/* 절세효과 계산기 - 히어로 섹션 역할 */}
        <TaxCalculator />

        {/* 핵심 혜택 - 계산기 바로 다음에 배치하여 빠르게 확인 가능 */}
        <ValueProposition />

        {/* 투자 구조 */}
        <InvestmentStructure />

        {/* 상품 비교 */}
        <ComparisonSection />

        {/* 소득 공제혜택 실제 사례 */}
        <TaxBenefitsExamples />

        {/* 회사 소개 */}
        <AboutSection />

        {/* 현재 투자중인 회사들 */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg">
              <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">현재 투자 중인 기업</h3>
              <div className="overflow-hidden md:bg-gray-50 md:rounded-xl py-6">
                {/* 데스크톱: 1줄 */}
                <div className="hidden md:block">
                  <div className="flex animate-scroll-right space-x-8 whitespace-nowrap">
                    {[
                      {name: 'SSG.COM', logo: '/images/ssg.jpeg'},
                      {name: '쿠팡', logo: '/images/coupang.jpg'},
                      {name: '무신사', logo: '/images/musinsa.png'},
                      {name: '11번가', logo: '/images/11st.jpeg'},
                      {name: '컬리', logo: '/images/kurly.png'},
                      {name: '지마켓', logo: '/images/gmarket.png'}
                    ].concat([
                      {name: 'SSG.COM', logo: '/images/ssg.jpeg'},
                      {name: '쿠팡', logo: '/images/coupang.jpg'},
                      {name: '무신사', logo: '/images/musinsa.png'},
                      {name: '11번가', logo: '/images/11st.jpeg'},
                      {name: '컬리', logo: '/images/kurly.png'},
                      {name: '지마켓', logo: '/images/gmarket.png'}
                    ]).concat([
                      {name: 'SSG.COM', logo: '/images/ssg.jpeg'},
                      {name: '쿠팡', logo: '/images/coupang.jpg'},
                      {name: '무신사', logo: '/images/musinsa.png'},
                      {name: '11번가', logo: '/images/11st.jpeg'},
                      {name: '컬리', logo: '/images/kurly.png'},
                      {name: '지마켓', logo: '/images/gmarket.png'}
                    ]).map((company, index) => (
                      <div key={index} className="flex flex-col items-center space-y-2 flex-shrink-0">
                        <div className="w-12 h-12 rounded-lg overflow-hidden bg-white">
                          <img
                            src={company.logo}
                            alt={`${company.name} 로고`}
                            className="w-full h-full object-contain"
                            onError={(e) => {
                              e.target.src = `https://via.placeholder.com/48x48/6B7280/FFFFFF?text=${company.name.charAt(0)}`;
                            }}
                          />
                        </div>
                        <span className="text-sm font-medium text-gray-700">{company.name}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 모바일: 2줄 - 첫 번째 줄 */}
                <div className="md:hidden mb-8">
                  <div className="overflow-hidden py-4">
                    <div className="flex animate-scroll-right space-x-6 whitespace-nowrap">
                      {[
                        {name: 'SSG.COM', logo: '/images/ssg.jpeg'},
                        {name: '쿠팡', logo: '/images/coupang.jpg'},
                        {name: '무신사', logo: '/images/musinsa.png'}
                      ].concat([
                        {name: 'SSG.COM', logo: '/images/ssg.jpeg'},
                        {name: '쿠팡', logo: '/images/coupang.jpg'},
                        {name: '무신사', logo: '/images/musinsa.png'}
                      ]).concat([
                        {name: 'SSG.COM', logo: '/images/ssg.jpeg'},
                        {name: '쿠팡', logo: '/images/coupang.jpg'},
                        {name: '무신사', logo: '/images/musinsa.png'}
                      ]).map((company, index) => (
                        <div key={index} className="flex flex-col items-center space-y-2 flex-shrink-0">
                          <div className="w-10 h-10 rounded-lg overflow-hidden bg-white">
                            <img
                              src={company.logo}
                              alt={`${company.name} 로고`}
                              className="w-full h-full object-contain"
                              onError={(e) => {
                                e.target.src = `https://via.placeholder.com/40x40/6B7280/FFFFFF?text=${company.name.charAt(0)}`;
                              }}
                            />
                          </div>
                          <span className="text-xs font-medium text-gray-700">{company.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* 모바일: 2줄 - 두 번째 줄 */}
                <div className="md:hidden">
                  <div className="overflow-hidden py-4">
                    <div className="flex animate-scroll-left space-x-6 whitespace-nowrap">
                      {[
                        {name: '11번가', logo: '/images/11st.jpeg'},
                        {name: '컬리', logo: '/images/kurly.png'},
                        {name: '지마켓', logo: '/images/gmarket.png'}
                      ].concat([
                        {name: '11번가', logo: '/images/11st.jpeg'},
                        {name: '컬리', logo: '/images/kurly.png'},
                        {name: '지마켓', logo: '/images/gmarket.png'}
                      ]).concat([
                        {name: '11번가', logo: '/images/11st.jpeg'},
                        {name: '컬리', logo: '/images/kurly.png'},
                        {name: '지마켓', logo: '/images/gmarket.png'}
                      ]).map((company, index) => (
                        <div key={index} className="flex flex-col items-center space-y-2 flex-shrink-0">
                          <div className="w-10 h-10 rounded-lg overflow-hidden bg-white">
                            <img
                              src={company.logo}
                              alt={`${company.name} 로고`}
                              className="w-full h-full object-contain"
                              onError={(e) => {
                                e.target.src = `https://via.placeholder.com/40x40/6B7280/FFFFFF?text=${company.name.charAt(0)}`;
                              }}
                            />
                          </div>
                          <span className="text-xs font-medium text-gray-700">{company.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 향후 계획 */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg">
              <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">더모아벤처스 향후 계획</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl text-center">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">리츠 투자</h4>
                  <p className="text-sm text-gray-600">부동산(리츠) 관련 투자 확대</p>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl text-center">
                  <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">유니콘 발굴</h4>
                  <p className="text-sm text-gray-600">유니콘 기업 발굴 및 투자 (배달의민족, 카카오 등)</p>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl text-center">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">바이오 투자</h4>
                  <p className="text-sm text-gray-600">유망한 바이오 기업 투자 확대</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
